
import React from 'react';
import type { ChartBaseProps } from "../types/chart-types";

interface LivisProgressHighchartsProps extends ChartBaseProps {
    data: Array<{
        name: string;
        value: number;
        color?: string;
    }>;
    backgroundColor?: string;
    height?: number;
    showLabel?: boolean;
}

const LivisProgressHighcharts: React.FC<LivisProgressHighchartsProps> = ({
    data = [],
    backgroundColor = 'var(--livis-index-tab-border-color)',
    height = 40,
    showLabel = true,
    title
}) => {
    // Get the first data point or default to 0
    const value = Math.max(0, Math.min(100, data[0]?.value ?? 0));
    const color = data[0]?.color ?? '#0066FF';

    return (
        <div className="livis-graph-progress-container">
            <div
                className="livis-graph-progress-background"
                style={{
                    height: `${height}px`,
                    background: backgroundColor,
                }}
            >
                <div
                    className="livis-graph-progress-fill"
                    style={{
                        width: `${value}%`,
                        background: color,
                    }}
                />
            </div>
        </div>
    );
};

export default LivisProgressHighcharts;